jQuery(document).ready(commonInit);

function commonInit() {
	//don't load anything on init after this in admin editor
	if(jQuery('#wpwrap').length !== 0) return false;
	
	setupMobileMenu();
	setupColumns();
	setupBanner();
	setupHero(); 
	setupScrollTriggers();
	
}

function setupMobileMenu() {
	
	jQuery("#mobile-menu-button").on("click", function(){
		jQuery("html").toggleClass("menu-open");
	});
	
}

function setupColumns() {
	
	jQuery('.wp-block-columns').each(function(){
		
		var current = jQuery(this);
		var columnCount = jQuery('> *', current).length;
		
		current.addClass('has-'+columnCount+'-columns');
		
	});
	
}

function setupBanner() {
	
}

function setupHero() {
	if(jQuery('#hero-carousel:not(.slick-initialized)').length) {
		jQuery('#hero-carousel:not(.slick-initialized)').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			rows: 1,
			slidesPerRow: 1,
			dots: false,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 10000,
			fade: true,
			easing: "linear",
			pauseOnHover: false,
			infinite: true,
			draggable: false,
			swipe: true,
			adaptiveHeight: false
		});
	}
}
function setupPageFade() {
    // Ensure the transition is ready to run
    requestAnimationFrame(() => {
        document.documentElement.classList.remove('loading');
    });
}

// Wait for everything to load, including images
window.onload = function() {
    setupPageFade();

	var banner = document.getElementById('global-alert');
	var closeButton = document.getElementById('close-alert');
	var html = document.getElementsByTagName('html')[0];
	
	if (!banner || !html) {
		return false;
	}
	
	var bannerHasBeenClosed = sessionStorage.getItem('bannerHasBeenClosed');
	
	if (!bannerHasBeenClosed) {
		html.classList.add('enable-global-alert');
	}
	
	if (closeButton) {
		closeButton.addEventListener('click', function() {
			html.classList.remove('enable-global-alert');
			sessionStorage.setItem('bannerHasBeenClosed', true);
		});
	}
	
}

//usage: var first = getUrlVars()['id'];
function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}
window.getUrlVars = getUrlVars;

function setCookie(cname, cvalue, exdays){
	 
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    
}
window.setCookie = setCookie;

function getCookie(cname) {
	
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    
    for(var i = 0; i <ca.length; i++){
        var c = ca[i];
        while (c.charAt(0) == ' '){
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
     
    return ""; 
    
}
window.getCookie = getCookie;
function setupScrollTriggers(){

	const elements = document.querySelectorAll('.scroll-alert:not(.set-up)');
	
	if ('IntersectionObserver' in window) {
	
		const options = {
			root: null,
			rootMargin: '0px 0px -10% 0px',
			threshold: 0
		};
		
		var observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if(entry.isIntersecting) {
					entry.target.classList.add('active');
				}
			});
		}, options);
		
		elements.forEach(element => {
			element.classList.add('set-up');
			observer.observe(element);
		});
		
	} else {
		
		for(var i=0; i<elements.length; i++) {
			elements[i].classList.add('set-up');
			elements[i].classList.add('active');	
		}
		
	}

}